import { Component, Input, OnInit } from '@angular/core';
import { NzNotificationService } from 'ng-zorro-antd/notification';
import { project } from 'src/app/Models/BasicForms/project';
import { Role } from 'src/app/Models/Commonmodule/role';
import { ApiService } from 'src/app/Service/api.service';

@Component({
  selector: 'app-project-mapping',
  templateUrl: './project-mapping.component.html',
  styleUrls: ['./project-mapping.component.css']
})

export class ProjectMappingComponent implements OnInit {
  @Input() drawerClose: Function;
  @Input() data: project;
  @Input() mappingData: [];

  TASK_CATEGORY_ID = 0;
  USER_ID = 1;
  IS_ACTIVE = true;
  searchText = "";

  constructor(private notificationSer: NzNotificationService, public _apiService: ApiService) { }

  ngOnInit(): void {
    this.searchText = "";
    this.TASK_CATEGORY_ID = 1;
    this.loadAllCategories();
    this.loadRoles();
  }

  displayFilterBox = false;
  flterBoxVisibleInvisible() {
    this.displayFilterBox = !this.displayFilterBox;
  }

  filterButtonType = "default";

  filterIsAppliedOrNot() {
    // if (this.chillingCenterID.length > 0) {
    //   this.filterButtonType= "primary";
    // } else {

    //   this.filterButtonType= "default";
    // }
  }

  close() {
    this.drawerClose();
    this.isSpinning = false;
  }

  isSpinning = false;

  save(addNew: boolean) {
    this.isSpinning = true;


    this._apiService.addProjectMappingDetails(this.data.ID, this.mappingData).subscribe(successCode => {


      if (successCode['code'] == "200") {
        this.notificationSer.success("Project Mapping Done Successfully", "");
        this.isSpinning = false;

        if (!addNew) {
          this.drawerClose();

        } else {
          // this.TASK_CATEGORY_ID = 1;
          this.onCategoryChange();
        }
      }

      else {
        this.notificationSer.error("Project Mapping Failed", "");
        this.isSpinning = false;
      }
    });
  }

  categoryList = [];
  loadAllCategories() {
    this._apiService.getAllCategories(0, 0, 'ID', 'desc', ' and IS_ACTIVE=1').subscribe(categoryData => {
      this.categoryList = categoryData['data'];

    }, err => {

    });
  }

  loadingRecords = false;

  onCategoryChange() {
    this.loadingRecords = true;

    this._apiService.getProjectDetails(this.data.ID, 0).subscribe(data => {
      this.loadingRecords = false;


      this.mappingData = data['data'];

    }, err => {

    });
  }

  roles: Role[];
  roleLoading = false;

  loadRoles() {
    this.roleLoading = true;
    this._apiService.getAllRoles(0, 0, '', '', " and ID not in (1,2)").subscribe(roles => {

      this.roles = roles['data'];
      this.roleLoading = false;

    }, err => {

      this.roleLoading = false;
    });
  }
}
